import React, { useEffect, useState } from 'react';
import { Table, Icon, Modal, Button, Input } from '@scuf/common';
import { RmaModelLiteMf } from 'models';
import useFetch from 'helpers/hooks/useFetch';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { RmaLiteMf } from 'resources/atoms/rmaManufaturaAtom';
import Alert from 'components/alert';
import { useRecoilState } from 'recoil';
import { RMAMANUFATURA } from 'resources';
import { toast } from 'react-toastify';
import useUser from 'helpers/hooks/useUser';

const EquipmentsAccordion: React.FC = () => {
    const { t } = useTranslation(['common']);
    const rmaDetail = useRecoilValue<RmaModelLiteMf>(RmaLiteMf);
    const [rmaState, setRmaState] = useRecoilState<RmaModelLiteMf>(RmaLiteMf);
    const [modalEdit, setModalEdit] = useState(false);
    const [newQuantity, setNewQuantity] = useState<number>();
    const [model, setModel] = useState<string>();
    const [itemId, setItemId] = useState<number>();
    const [serial, setSerial] = useState<string>();

    const user = useUser();
    const roleUser = user.user?.role;

    const [updatedItem, updateQuantityItem, loading] = useFetch({
        url: `${RMAMANUFATURA.repairCenterUrl}/UpdateQuantityItem/${itemId}/${newQuantity}`,
        method: 'PUT',
        onError: 'Erro ao alterar a quantidade do item!',
        onSuccess: 'Quantidade Alterada com Sucesso!'
    });

    function openModalEdit(serial: string, model: string, itemId: number) {
        setModel(model);
        setSerial(serial);
        setItemId(itemId);
        setModalEdit(true);
    }

    useEffect(() => {
        if (updatedItem) {
            setRmaState(prev => {
                const updatedEquip = prev.rmaItemsEquipmentManufacturing.map(eq => {
                    if (eq.id == itemId) {
                        return { ...eq, quantity: newQuantity };
                    }
                    return eq;
                });
                return { ...prev, rmaItemsEquipmentManufacturing: updatedEquip };
            });
            setNewQuantity(0);
            setModalEdit(false);
        }
    }, [updatedItem]);

    async function editQuantityItem() {
        try {
            await updateQuantityItem();
        } catch (error) {
            toast.error(updatedItem?.message);
        }
    }
    return (
        <>
            {rmaState?.rmaItemsManufacturing && rmaState?.rmaItemsManufacturing.length > 0 ? (
                <div>
                    <Table>
                        <Table.Header>
                            <Table.HeaderCell content={t('translation.Model')} />
                            <Table.HeaderCell content={t('translation.SerialNumber')} />
                            <Table.HeaderCell content={t('rmamanufatura:manage_eos.translation.ProblemLocation')} />
                            <Table.HeaderCell content={t('translation.Description')} />
                            <Table.HeaderCell content={t('translation.Quantity')} />
                            <Table.HeaderCell content={'GBE'} />
                        </Table.Header>
                        <Table.Body>
                            {rmaState?.rmaItemsManufacturing?.map((item, index) => {
                                const equipment = rmaState?.rmaItemsEquipmentManufacturing?.find(
                                    eq => eq.rmaItemsManufacturingId === item.id
                                );

                                return (
                                    <Table.Row key={item.id || index}>
                                        <Table.Cell>{item?.model || '--'}</Table.Cell>
                                        <Table.Cell>{equipment?.serialNumber || '--'}</Table.Cell>
                                        <Table.Cell>
                                            {equipment?.problemLocation?.name || equipment?.problemLocationId || '--'}
                                        </Table.Cell>
                                        <Table.Cell>{equipment?.problemTypeDescription || '--'}</Table.Cell>
                                        <Table.Cell>
                                            {' '}
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                {' '}
                                                <span>{equipment?.quantity || '0'}</span>{' '}
                                                {(roleUser === '1' || roleUser === '2') && (
                                                    <Icon
                                                        name="edit"
                                                        root="common"
                                                        size="small"
                                                        color="critical"
                                                        style={{ marginLeft: 'auto' }}
                                                        onClick={() => {
                                                            openModalEdit(equipment?.serialNumber!, item.model!, item.id);
                                                        }}
                                                        title={t('Editar quantidade')}
                                                    />
                                                )}
                                            </div>{' '}
                                        </Table.Cell>{' '}
                                        <Table.Cell>{equipment?.gbe || '-'}</Table.Cell>
                                    </Table.Row>
                                );
                            })}
                        </Table.Body>
                    </Table>
                </div>
            ) : (
                <Alert text={t('empty.NoShipping')}></Alert>
            )}

            <Modal open={modalEdit} onOpenChange={modalEdit} className="edit-model-modal" size="small">
                <Modal.Content>
                    <div style={{ padding: '2rem', backgroundColor: '#f9f9f9', borderRadius: '12px' }}>
                        <h2 style={{ marginBottom: '1.5rem' }}>{t('common:translation.EditQuantity')}</h2>
                        <h3 style={{ marginBottom: '1.5rem' }}>
                            {'Modelo: '}
                            {model}
                        </h3>
                        <h3 style={{ marginBottom: '1.5rem' }}>
                            {'Serial: '}
                            {serial}
                        </h3>
                        <div>
                            <Input
                                content={'common:translation.Quantity'}
                                label={t('common:translation.EditNewQuantity')}
                                placeholder={t('common:translation.EditNewQuantity')}
                                value={newQuantity?.toString()}
                                onChange={value => {
                                    setNewQuantity(Number(value));
                                }}
                            ></Input>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginTop: '2rem' }}>
                            <Button
                                type="secondary"
                                content={t('common:actions.Cancel')}
                                onClick={() => setModalEdit(false)}
                                disabled={loading}
                                loading={loading}
                            />
                            <Button
                                type="primary"
                                content={t('common:actions.Save')}
                                onClick={() => {
                                    editQuantityItem();
                                }}
                                disabled={loading || !newQuantity}
                                loading={loading}
                            />
                        </div>
                    </div>
                </Modal.Content>
            </Modal>
        </>
    );
};

export default EquipmentsAccordion;
